import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Document } from '@contentful/rich-text-types';

import {
  IFooterConfig,
  IQuickLink,
  IQuickLinkList,
  IQuickLinks,
} from '../models/footer.interfaces';

/**
 * A static helper to convert contentful data to the generic IFooterConfig interface.
 * Contenful adds heaps of supporting data for its own API, so even if we create
 * a content model that is like for like, we can't simply cast the object. Hence,
 * created this helper to keep the component logic simple.
 */
export class FooterHelper {
  static toFooterConfig(data: any | undefined): IFooterConfig | undefined {
    if (data) {
      const config: IFooterConfig = {
        displayBrandLogo: !!data.displayBrandLogo,
        quickLinks: this.toQuickLinks(data.quickLinks?.fields),
        disclaimer: this.richTextToHtml(data.disclaimer),
        poweredBy: !!data.poweredBy,
      };

      return config;
    }
    return;
  }

  private static toQuickLinks(data: any | undefined): IQuickLinks | undefined {
    if (data) {
      const config: IQuickLinks = {
        left: this.toQuickLinkBlock(data.left?.fields),
        right: this.toQuickLinkBlock(data.right?.fields),
        custom: data.custom,
      };

      return config;
    }

    return;
  }

  private static toQuickLinkBlock(
    data: any | undefined
  ): IQuickLinkList | undefined {
    return data
      ? {
          heading: data.heading,
          links: this.toQuickLinkList(data.links),
        }
      : undefined;
  }

  private static toQuickLinkList(data: any | undefined): IQuickLink[] {
    return data ? data.map((link: Record<string, unknown>) => link.fields) : [];
  }

  private static richTextToHtml(content: Document | undefined): string {
    return content ? documentToHtmlString(content) : '';
  }
}
